/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import classNames from 'classnames';
import { Hyperlink, Image } from 'ts-paragon';

import messages from './messages';

const SmallLayout = () => {
  const { formatMessage } = useIntl();
  const siteConfig = getConfig();
  const customSiteSubtitle = siteConfig.CUSTOM_SITE_SUB_TITLE ? siteConfig.CUSTOM_SITE_SUB_TITLE : siteConfig.SITE_SUB_TITLE;
  const customSiteTitle = siteConfig.CUSTOM_SITE_TITLE ? siteConfig.CUSTOM_SITE_TITLE : siteConfig.SITE_TITLE;

  return (
    <span className="bg-primary-400 w-100">
      <div className="col-md-12 small-screen-top-stripe" />
      <div>
        <Hyperlink destination={getConfig().MARKETING_SITE_BASE_URL}>
          <Image className="logo-small" alt={getConfig().SITE_NAME} src={getConfig().LOGO_WHITE_URL} />
        </Hyperlink>
        <div className="d-flex align-items-center m-3.5">
          <div className={classNames({ 'small-yellow-line mr-n2.5': getConfig().SITE_NAME === 'edX' })} />
          <h1
            className={classNames(
              'text-white mt-3.5 mb-3.5',
            )}
          >
            {!customSiteSubtitle ? (
              <span>
                {getConfig().SITE_TITLE ? getConfig().SITE_TITLE : 'Welcome to your program!'}
                <span className="text-accent-a d-inline-block">
                  {getConfig().SITE_SUB_TITLE}
                </span>
                {getConfig().SITE_NAME === 'CMU' && (
                  <p className="poweredby">Powered by TalentSprint</p>
                )}
              </span>
            )
              : (
                <>
                  {customSiteTitle || 'Welcome to your program!'}
                  <span className="text-accent-a d-inline-block custom-site-subtitle">
                    <span dangerouslySetInnerHTML={{ __html: customSiteSubtitle }} />
                  </span>
                </>
              )}
          </h1>
        </div>
      </div>
    </span>
  );
};

export default SmallLayout;
